import { IconButton } from "@mui/material";
import Stack from "@mui/material/Stack";
import { StyledImg, StyledImgBox } from "./styled";
import { EventSelector } from "../../eventSelectPage/eventSelectBox/eventSelector/EventSelector";
import { useEventDropdown } from "../../eventSelectPage/hooks/useEventDropdown/useEventDropdown";
import EventHelper from "../../../common/network/helpers/event/EventHelper";
import { EventSelectionHeaderWrapper } from "../../eventSelectPage/styled/styled";
import { filterEventsByEndDate } from "../../eventSelectPage/utils";
import { BadgeSyncChip } from "./components/BadgeSyncChip";
import { ColocatedShowDataSyncChip } from "./components/ColocatedShowDataSyncChip";

type Props = {
  onRxLogoClick: () => void;
  logoUrl: string;
  isFreya?: boolean;
};

export const LogoContainer = ({ onRxLogoClick, logoUrl, isFreya }: Props) => {
  const { selectedOption, isButtonClicked, filteredOptions, isSubmitting, onDropdownClick, onChange, selectAndRefresh, onClickAway } =
    useEventDropdown({ options: filterEventsByEndDate(EventHelper.mercuryEventOptions) });

  return (
    <Stack direction="row" spacing={2} alignItems="center" width={"100%"} data-testid="logo-container">
      <StyledImgBox $isFreya={isFreya}>
        <IconButton data-testid="logo-button" size="large" onClick={onRxLogoClick}>
          <StyledImg data-testid="logo-img" src={logoUrl} />
        </IconButton>
      </StyledImgBox>
      {!isFreya && (
        <EventSelectionHeaderWrapper data-testid="logo-event-switch">
          <EventSelector
            options={EventHelper.mercuryEventOptions}
            isButtonClicked={isButtonClicked}
            onDropdownClick={onDropdownClick}
            isFormDisabled={isSubmitting}
            filteredOptions={filteredOptions}
            onChange={onChange}
            onSelect={selectAndRefresh}
            selectedOption={selectedOption}
            onClickAway={onClickAway}
          />
        </EventSelectionHeaderWrapper>
      )}
      {!isFreya && <BadgeSyncChip />}
      {isFreya && <ColocatedShowDataSyncChip />}
    </Stack>
  );
};
